import { AnyAction } from '@reduxjs/toolkit'

import { RECEIVE_UPDATE_SUBSCRIPTION_TIER } from '@/actions'
import { syncSlice } from '@/helpers/redux'
import { UserProfileSlice } from '@/models'

import { PROFILE } from '../action-types'

const defaultState: UserProfileSlice = {
    fetchSuccessful: null,
    shouldFetch: true,
}

export default (state = defaultState, action: AnyAction): UserProfileSlice => {
    const { type, data } = action

    switch (type) {
        case PROFILE.REQUEST_PROFILE:
            return { ...state, shouldFetch: false }

        case PROFILE.RECEIVE_PROFILE:
            return { ...state, ...data }

        case PROFILE.SYNC_PROFILE: {
            const { key, update } = data

            return {
                ...state,
                // eslint-disable-next-line @typescript-eslint/no-explicit-any
                [key]: syncSlice((state as any)[key] || [], update),
            }
        }

        case RECEIVE_UPDATE_SUBSCRIPTION_TIER: {
            return { ...state, shouldFetch: true }
        }

        default:
            return state
    }
}
